import Fetcher from "./Shared/FetchService";
export default class CaseloadService {
    static getCourseRiskSummary() {
        return Fetcher.getSingleResponse("/aviso/advisor/getCaseloadCourseRiskSummary");
    }
    static getPersistenceRiskSummary() {
        return Fetcher.getSingleResponse("/aviso/advisor/getCaseloadPersistenceRiskSummary");
    }
}
